import { PreferenceSecondaryColorsEnum, PreferenceThemeColorsEnum, PreferenceThemeSlugsEnum } from "./Preference.enums";

type ThemeOptions = {
  title: string;
  description?: string;
  value: PreferenceThemeSlugsEnum;
  color: string;
  secondaryColor?: string;
};

export const ThemeOptions: ThemeOptions[] = [
  {
    title: "Eclipse",
    description: "padrão",
    value: PreferenceThemeSlugsEnum.CLEAN,
    color: PreferenceThemeColorsEnum[PreferenceThemeSlugsEnum.CLEAN],
    secondaryColor: PreferenceSecondaryColorsEnum[PreferenceThemeSlugsEnum.CLEAN],
  },
  {
    title: "Heart",
    value: PreferenceThemeSlugsEnum.HEART,
    color: PreferenceThemeColorsEnum[PreferenceThemeSlugsEnum.HEART],
  },
  {
    title: "Ocean",
    value: PreferenceThemeSlugsEnum.OCEAN,
    color: PreferenceThemeColorsEnum[PreferenceThemeSlugsEnum.OCEAN],
  },
  {
    title: "Magic",
    value: PreferenceThemeSlugsEnum.MAGIC,
    color: PreferenceThemeColorsEnum[PreferenceThemeSlugsEnum.MAGIC],
  },
  {
    title: "Sun",
    value: PreferenceThemeSlugsEnum.SUN,
    color: PreferenceThemeColorsEnum[PreferenceThemeSlugsEnum.SUN],
  },
  {
    title: "Mars",
    value: PreferenceThemeSlugsEnum.MARS,
    color: PreferenceThemeColorsEnum[PreferenceThemeSlugsEnum.MARS],
  },
  {
    title: "Mint",
    value: PreferenceThemeSlugsEnum.MINT,
    color: PreferenceThemeColorsEnum[PreferenceThemeSlugsEnum.MINT],
  },
];
